<template>
  <thead>
    <template v-if="showRibbons">
      <tr class="cusmtom-thead-color">
        <td rowspan="3" class="text-center p-3 custom-header-label">
          {{ getLabel }}
        </td>
        <td rowspan="3" class="text-center p-3 custom-header-label">
          {{ $t('production.has') }}
        </td>
      </tr>
      <tr class="cusmtom-thead-color">
        <td
          colspan="3"
          v-for="(_, week) in columns"
          :key="week"
          class="text-center p-3"
        >
          <strong>{{ week }}</strong>
        </td>
      </tr>
      <tr>
        <template v-for="(ribbon, i) in columns">
          <td
            class="text-center p-3"
            v-bind:style="getStyleCellRibbon(ribbon[0])"
          >
            {{
              translateDataBaseText(
                ribbon[0].color_name,
                ribbon[0].other_values
              )
            }}
          </td>
          <td class="text-center p-3">
            <strong>{{ $t('common_words.allotment') }}/Ha</strong>
          </td>
          <td class="text-center p-3">
            <strong>%/{{ $t('common_words.allotment') }}</strong>
          </td>
        </template>
      </tr>
    </template>
    <template v-else>
      <tr class="cusmtom-thead-color">
        <td class="text-center p-3 custom-header-label">
          {{ getLabel }}
        </td>
        <td class="text-center p-3 custom-header-label">
          {{ $t('production.has') }}
        </td>
        <td v-for="(_, week) in columns" :key="week" class="text-center p-3">
          <strong>{{ week }}</strong>
        </td>
      </tr>
    </template>
  </thead>
</template>
<script>
import i18n from 'src/i18n';
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  computed: {
    getLabel() {
      return this.labelFirstCell
        ? this.labelFirstCell
        : i18n.t('common_words.allotment');
    },
  },
  name: 'thead-percent-pockets',
  props: {
    labelFirstCell: {
      type: String,
      default: null,
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    showRibbons: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [MixinTranslate],
  methods: {
    getStyleCellRibbon(row) {
      return (
        'background-color:' +
        row.color_code +
        ';color:' +
        row.color_text +
        '; font-weight: bold;'
      );
    },
  },
};
</script>
